import { render, staticRenderFns } from "./modalCedisNavbar.vue?vue&type=template&id=264ca3ac&scoped=true"
import script from "./modalCedisNavbar.vue?vue&type=script&lang=js"
export * from "./modalCedisNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ca3ac",
  null
  
)

export default component.exports